import React from "react";

import Wrapper from "./style";

const Overlay = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default Overlay;
